import styled from "styled-components";
import { TableRow } from "@mui/material";

export const StyledDocumentsListMobileRow = styled(TableRow)`
    .tablecell-root.tablecell-root.tablecell-root {
        display: flex;
        flex-flow: column;
        padding: 10px;
        cursor: pointer;
        .itemHeader {
            display: flex;
            justify-content: space-between;
        }

        .label {
            font-size: var(--size-14);
            color: var(--color-grey-800);
            text-align: left;
            word-break: break-word;
            border-bottom: none;
            &.documentTitle {
                padding-bottom: 0;
                margin: 10px 0;
                font-size: var(--size-16);
                font-weight: bold;
                line-height: 22px;
                color: var(--color-secondary);
            }

            &.description {
                color: var(--color-grey-900);
            }
        }
    }
`;
